import styled from 'styled-components'
import { match } from 'ts-pattern'

import { useTranslation } from '@root/shared/localization'

import { TradeType } from '../../model'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  type: TradeType.Type
} & ClassNameProps

export const TradeTypeCell: React.FC<Props> = ({ className, type }) => {
  const { t } = useTranslation()
  const label = match(type)
    .with('limit-buy', () => t('trading.limit_buy'))
    .with('limit-sell', () => t('trading.limit_sell'))
    .with('market-buy', () => t('trading.market-buy'))
    .with('market-sell', () => t('trading.market-sell'))
    .exhaustive()

  return (
    <Root $type={type} className={className}>
      {label}
    </Root>
  )
}

const Root = styled.div<{ $type: TradeType.Type }>`
  text-transform: capitalize;

  color: ${(props) =>
    TradeType.isBuy(props.$type) ? 'var(--up-9)' : 'var(--down-9)'};

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
